import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCpuProcessorRefresh = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "none",
		d: "M16.6681 17.9759L18.6128 18.9632C17.9161 19.5782 17.0015 19.9518 15.9987 19.9518C13.8165 19.9518 12.0469 18.1822 12.0469 16M15.3301 14.0228L13.3855 13.0355C14.0821 12.4206 14.9968 12.0469 15.9996 12.0469C18.1817 12.0469 19.9513 13.8166 19.9513 15.9987M12.8177 27.9967V25.3022M19.1804 27.9967V25.3022M12.8177 6.69986V4.00525M19.1804 6.69986V4.00525M6.69463 12.823H4M6.69463 19.178H4M27.9993 12.823H25.2943M27.9993 19.178H25.2943M6.69401 20.114C6.69401 23.1511 8.59465 25.3022 11.6409 25.3022H20.3579C23.4053 25.3022 25.2956 23.1511 25.2956 20.114V11.8991C25.2956 8.85288 23.4053 6.70056 20.3579 6.70056H11.6409C8.60373 6.70056 6.69401 8.85288 6.69401 11.8991V20.114Z",
		stroke: "#596180",
		strokeWidth: 1.8,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgCpuProcessorRefresh;
